import React from 'react';

const IsBotContext = React.createContext(false);

export const useIsBot = () => React.useContext(IsBotContext);

export const IsBotProvider: React.FC<{ isBot: boolean; children: React.ReactNode }> = ({
  isBot,
  children,
}) => <IsBotContext.Provider value={isBot}>{children}</IsBotContext.Provider>;
